import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { PapiUser } from '@wix/da-papi-types';
import { BiData, MessageIconClickBiEvent } from '@wix/da-bi/pkg/events';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/MessageModal';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { Alert } from '@wix/da-ds/pkg/Icons/Confirmations/Alert';

import s from './OriginalsDeclineSuccessModal.scss';

interface Props {
  requestingUser: PapiUser;
  onRequestClose: () => void;
}

const OriginalsDeclineSuccessModal: React.FC<Props> = ({ requestingUser, onRequestClose }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  return (
    <MessageModal
      className={s['root']}
      isOpen
      variant={isMobile ? 'vertical' : 'horizontal'}
      image={<Alert />}
      title={t('studio.modals.originalsDeclineSuccess.title')}
      message={
        <ul className={s['message']}>
          <li>{t('studio.modals.originalsDeclineSuccess.message.item1')}</li>
          <li>{t('studio.modals.originalsDeclineSuccess.message.item2')}</li>
        </ul>
      }
      onRequestClose={onRequestClose}
      footerButtons={[
        <TextButton
          key="cancel"
          variant="main"
          size="medium"
          href={Url.userMessageLink(requestingUser.username)}
          biData={BiData<MessageIconClickBiEvent>({
            evid: 470,
            recipientid: requestingUser.useridUuid,
            sectionname: 'originals',
          })}
        >
          {t('common.sendMessage')}
        </TextButton>,
        <BrandedButton key="confirm" variant="brand-green" size="medium" onClick={onRequestClose}>
          {t('common.gotIt')}
        </BrandedButton>,
      ]}
    />
  );
};
OriginalsDeclineSuccessModal.displayName = 'OriginalsDeclineSuccessModal';

export default OriginalsDeclineSuccessModal;
